/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDiagnosisApi } from '../api/patientdiagnosis.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientDiagnosisData,PatientDiagnosis } from '../../../interfaces/masters/patientdiagnosis';

@Injectable()
export class PatientDiagnosisService extends PatientDiagnosisData {

  constructor(private api: PatientDiagnosisApi) {
    super();
  }


  list(url: string): Observable<PatientDiagnosis[]> {
    return this.api.list(url);
  }
users(url: string): Observable<any[]> {
    return this.api.users(url);
  }
  getById(url:string): Observable<PatientDiagnosis>{
      return this.api.getById(url);
  }

  create(url: string, data:PatientDiagnosis): Observable<PatientDiagnosis> {
    return this.api.add(url,data);
  }
search(url: string, data:any): Observable<any> {
    return this.api.search(url,data);
  }
  update(url: string, data:PatientDiagnosis): Observable<PatientDiagnosis> {
    return this.api.update(url,data);
  }



  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
